var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup82(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 105,
    viewBox: "0 0 439 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_2404_1405)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.5,
    cy: 69,
    rx: 210.5,
    ry: 11,
    fill: "url(#paint0_linear_2404_1405)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.439 23.9179C362.716 25.4038 362.029 27.1034 360.298 29.0078C358.575 30.905 355.869 32.9448 352.259 35.0888C345.044 39.3747 334.297 44.0331 320.803 48.7802C293.82 58.2727 255.919 68.0993 213.497 76.0066C171.075 83.9138 132.178 88.4018 103.588 89.2677C89.2902 89.7008 77.5857 89.2274 69.3113 87.8286C65.1719 87.1289 61.9127 86.201 59.6211 85.0522C57.321 83.8991 56.0673 82.5613 55.7903 81.0754C55.5133 79.5896 56.2009 77.89 57.9312 75.9856C59.655 74.0884 62.3611 72.0486 65.9703 69.9046C73.1852 65.6187 83.9331 60.9603 97.4269 56.2132C124.409 46.7207 162.31 36.8941 204.733 28.9868C247.155 21.0796 286.051 16.5916 314.642 15.7257C328.939 15.2926 340.644 15.766 348.918 17.1648C353.058 17.8645 356.317 18.7924 358.609 19.9412C360.909 21.0943 362.162 22.4321 362.439 23.9179Z",
    stroke: "url(#paint1_linear_2404_1405)",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2404_1405",
    x: 0,
    y: 49,
    width: 439,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2404_1405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2404_1405",
    x1: 77.4342,
    y1: 52.0769,
    x2: 88.352,
    y2: 136.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC72FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2404_1405",
    x1: 43.3788,
    y1: 117.494,
    x2: 44.1439,
    y2: 13.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC72FF",
    stopOpacity: 0.06
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup82);
export default __webpack_public_path__ + "static/media/group-82.fc1e71aa54d45ab4cb9aa1c8d4aba0bf.svg";
export { ForwardRef as ReactComponent };